<template>
  <div class="empty-wallet align-middle align-center grid-y margin-top-s">
    <span class="wallet"></span>
    <p class="margin-top-xs large text-center">
      {{ WALLET.emptyWallet.description }}
    </p>
    <p class="margin-bottom-s text-center">
      {{ WALLET.emptyWallet.subDescription }}
    </p>
    <Button :variant="'link'" class="link-lg" @click.prevent="addCard">
      {{ WALLET.emptyWallet.addPaymentLabel }}
    </Button>
  </div>
</template>
<script setup>
import Button from '@atomic-ui/button/Button';
import { fireTag } from '@vue-util/tagManager';
import { WALLET } from 'config';
import { useWalletStore } from '@/stores/useWalletStore';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { useProfileStore } from '@/stores/useProfileStore';
import { useDashboardStore } from '@/stores/useDashboardStore';
import useSlideout from '@/composables/useSlideout';
import { useUserSessionId } from '@/composables/useUserSessionId';

const walletStore = useWalletStore();
const envPropsStore = useEnvPropsStore();
const profileStore = useProfileStore();
const dashboardStore = useDashboardStore();
const { showSlideout, toggleSlideout } = useSlideout();
const { userSessionIdInit } = useUserSessionId();

const onCardSubmit = async (response) => {
  const severity = response?.walletTender?.msg || 'error';
  if (severity === 'success') {
    await walletStore.fetchCreditCards();
    await dashboardStore.fetchRewardsSummary();
    dashboardStore.setGlobalNotification({
      type: 'success',
      closeButton: true,
      message: WALLET.cardSaveSuccess,
    });
  } else {
    const message = response?.walletTender?.error?.message || '';
    dashboardStore.setGlobalNotification({
      type: 'error',
      closeButton: true,
      message,
    });
  }
  toggleSlideout('add-SlideOut');
};

const addCard = () => {
  showSlideout('add-SlideOut', WALLET.addCreditCardTitle, import('@nuxt-common/payment-cards/app/components/AddEditDeleteCard'), true, {
    cardAction: 'add',
    callback: onCardSubmit,
    isOnlyMacysOption: false,
    tokenizationIframeSource: envPropsStore.tokenizationIframeSource,
    tokenizationPciIframeSrc: envPropsStore.tokenizationPciIframeSrc,
    deviceType: envPropsStore.deviceType,
    isCheckboxDisable: true,
    userAddress: profileStore.profile?.shippingAddress,
    userEmail: profileStore.profile?.email,
  });
  userSessionIdInit();

  fireTag('link', {
    ...WALLET.tag.addCard,
  });
};
</script>

<style lang="scss" brand="mcom" scoped>
@import '@csgIcons/_wallet.scss';
</style>

<style lang="scss" brand="bcom" scoped>
@import '@csgIcons/_bwallet.scss';
.wallet {
  @extend .bwallet;
}
</style>
